import {useEffect} from 'react';
import {useDocsetManifest} from '../../context/DocsetContext';
import {resolveResource} from '../../utils/resources';

export function DocsetStyles() {
  const manifest = useDocsetManifest();

  useEffect(() => {
    const createdLinks: HTMLLinkElement[] = [];
    const seen = new Set<string>();

    manifest.assets.stylesheet.forEach((relativeHref) => {
      const href = resolveResource(manifest, relativeHref);
      if (seen.has(href)) {
        return;
      }
      seen.add(href);
      // Avoid duplicating links if already present
      const existing = document.querySelector<HTMLLinkElement>(`link[data-docset-style="${href}"]`);
      if (existing) {
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.dataset.docsetStyle = href;
      document.head.appendChild(link);
      createdLinks.push(link);
    });

    const accent = manifest.theme?.accentColor;
    if (accent) {
      document.documentElement.style.setProperty('--accent-color', accent);
    }

    // Load Google fonts for default theme when not provided as webFonts
    // Matches fonts used by the editor/playground
    if (!document.querySelector('link[data-docset-fonts="google"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Urbanist:wght@100..900&family=Google+Sans+Code:wght@400..700&display=swap';
      link.dataset.docsetFonts = 'google';
      document.head.appendChild(link);
      createdLinks.push(link);
    }

    return () => {
      // Only remove links we inserted (those appended above)
      createdLinks.forEach((link) => {
        if (link.parentNode === document.head) {
          document.head.removeChild(link);
        }
      });
      if (accent) {
        document.documentElement.style.removeProperty('--accent-color');
      }
    };
  }, [manifest]);

  return null;
}
